import type React from 'react'
import { createContext } from 'react'

type ContextType = {
  inputRef: React.Ref<HTMLInputElement>;
  listId: string;
  onSelect: (value: string | null, options?: { closeAfterSelection?: boolean }) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const AutocompleteContext = createContext<ContextType>({
  inputRef: { current: null },
  listId: '',
  onSelect: () => {},
  open: false,
  setOpen: () => {},
})
